import getRefreshToken from './refresh';

export const endpoint = (baseUrl, resource = []) =>
  baseUrl + '/' + resource.join('/');

export default async function request(
  baseUrl,
  endpoint,
  body = {},
  options = {},
  method,
  lastRequest = null
) {
  const token = sessionStorage.getItem('AUTH_TOKEN');
  let response;
  options.headers = {};
  if (token !== null) {
    options.headers.Authorization = `Bearer ${token}`;
  }

  if (method !== 'GET') {
    options.headers['Content-type'] = 'application/json;charset=UTF-8';
    response = await fetch(endpoint, {
      method,
      ...options,
      body: JSON.stringify(body),
    });
  } else {
    response = await fetch(endpoint, {
      method,
      ...options,
    });
  }

  if (!response.ok) {
    if (response.status === 401) {
      const refreshResult = await getRefreshToken(baseUrl);
      if (refreshResult) {
        if (lastRequest !== null) {
          return response;
        }
        return await request(
          baseUrl,
          endpoint,
          body,
          options,
          method,
          response
        );
      }
    }
  }

  return response;
}
